import { createSceneReducer } from 'reducers/reducers-util';
import rfisDataReducer from 'components/admin/rfis/store/reducers.data';

export default createSceneReducer(rfisDataReducer);
